<template>
	<div id="admin-content-container" class="p-3 container-fluid">
		<div class="mb-2 mb-xl-4 row">
			<div class="d-none d-sm-block col-auto">
				<h3>{{ __('translations.title.dashboard') }}</h3>
			</div>
		</div>
		<div class="row">
		  <div class="d-flex col-lg-6 col-xl-6" v-if="statusses.length > 0">
		  	<div class="w-100">
		  	  <div class="row">
		  	  	<div class="col-sm-6" v-for="(status, index) in statusses" :key="'status-' + index">
		  	  	  <status :status="status"></status>
		  	  	</div>
			  </div>
			</div>
		  </div>
		  <div class="d-flex col-lg-6 col-xl-6">
			<wikidata-locations></wikidata-locations>
    	  </div>
		</div>
		<div class="row">
		  <div class="d-flex col-lg-6">
	    	<user-performance></user-performance>
		  </div>
	      <div class="d-flex col-lg-6">
			<wikidata-tag-cloud></wikidata-tag-cloud>
		  </div>
		</div>
	</div>
</template>

<script>
import UserPerformance from './dashboard/UserPerformance'
import Status from './dashboard/Status'
import WikidataLocations from './dashboard/WikidataLocations'
import WikidataTagCloud from './dashboard/WikidataTagCloud'

export default {
	components: {
		Status,
		UserPerformance,
		WikidataLocations,
		WikidataTagCloud
	},
	data() {
		return {
			statusses: [],
		}
	},
	created() {
		axios.get('/dashboardNumbers').then(response => {
        	this.statusses = response.data;
        }).catch(err => {
            console.log(err)
        })
	},
}
</script>